(ns machtfit.startpage.spinner
  (:require [machtfit.core :as machtfit]
            [machtfit.translation :refer [tr]]))

(defn spinner []
  [:div.loader [:div.loader_spinner
                [:img {:src (machtfit/static "img/machtfit-supersign-loading.gif")}]
                [:p (tr "Laden...")]]])
